/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WorkManualGradingFinishedParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('finished')],
]);
export class WorkManualGradingFinished extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WorkManualGradingFinishedParser.decode(input).map(res => new WorkManualGradingFinished(res));
    }
    static unsafeDecode(input) {
        return WorkManualGradingFinished.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WorkManualGradingFinishedParser.encode(data);
    }
    static schema() {
        return WorkManualGradingFinishedParser.schema();
    }
}
